import moment from 'moment';
import { i18n } from 'src/i18n';
import resourceEnumerators from 'src/modules/resource/resourceEnumerators';
import schemas from 'src/modules/shared/yup/yupImporterSchemas';

export default [
  {
    name: 'icon',
    label: i18n('entities.resource.fields.icon'),
    schema: schemas.images(
      i18n('entities.resource.fields.icon'),
      {
        max: 1,
      },
    ),
  },
  {
    name: 'name',
    label: i18n('entities.resource.fields.name'),
    schema: schemas.string(
      i18n('entities.resource.fields.name'),
      {
        required: true,
      },
    ),
  },
  {
    name: 'type',
    label: i18n('entities.resource.fields.type'),
    schema: schemas.enumerator(
      i18n('entities.resource.fields.type'),
      {
        options: resourceEnumerators.type,
      },
    ),
  },
  {
    name: 'validatedBy',
    label: i18n('entities.resource.fields.validatedBy'),
    schema: schemas.relationToMany(
      i18n('entities.resource.fields.validatedBy'),
      {},
    ),
  },
  {
    name: 'rejectedBy',
    label: i18n('entities.resource.fields.rejectedBy'),
    schema: schemas.relationToMany(
      i18n('entities.resource.fields.rejectedBy'),
      {},
    ),
  },
  {
    name: 'closedBy',
    label: i18n('entities.resource.fields.closedBy'),
    schema: schemas.relationToMany(
      i18n('entities.resource.fields.closedBy'),
      {},
    ),
  },
  {
    name: 'participants',
    label: i18n('entities.resource.fields.participants'),
    schema: schemas.relationToMany(
      i18n('entities.resource.fields.participants'),
      {},
    ),
  },
  {
    name: 'administrators',
    label: i18n('entities.resource.fields.administrators'),
    schema: schemas.relationToMany(
      i18n('entities.resource.fields.administrators'),
      {},
    ),
  },
  {
    name: 'viewers',
    label: i18n('entities.resource.fields.viewers'),
    schema: schemas.relationToMany(
      i18n('entities.resource.fields.viewers'),
      {},
    ),
  },
  {
    name: 'parentResource',
    label: i18n('entities.resource.fields.parentResource'),
    schema: schemas.relationToOne(
      i18n('entities.resource.fields.parentResource'),
      {},
    ),
  },
  {
    name: 'locationGoogle',
    label: i18n('entities.resource.fields.locationGoogle'),
    schema: schemas.string(
      i18n('entities.resource.fields.locationGoogle'),
      {},
    ),
  },
  {
    name: 'location',
    label: i18n('entities.resource.fields.location'),
    schema: schemas.relationToOne(
      i18n('entities.resource.fields.location'),
      {},
    ),
  },
  {
    name: 'keywords',
    label: i18n('entities.resource.fields.keywords'),
    schema: schemas.relationToMany(
      i18n('entities.resource.fields.keywords'),
      {},
    ),
  },
  {
    name: 'formCategory',
    label: i18n('entities.resource.fields.formCategory'),
    schema: schemas.relationToMany(
      i18n('entities.resource.fields.formCategory'),
      {},
    ),
  },
  {
    name: 'formTemplate',
    label: i18n('entities.resource.fields.formTemplate'),
    schema: schemas.relationToOne(
      i18n('entities.resource.fields.formTemplate'),
      {},
    ),
  },
  {
    name: 'relatedTo',
    label: i18n('entities.resource.fields.relatedTo'),
    schema: schemas.enumerator(
      i18n('entities.resource.fields.relatedTo'),
      {
        options: resourceEnumerators.relatedTo,
      },
    ),
  },
  {
    name: 'status',
    label: i18n('entities.resource.fields.status'),
    schema: schemas.enumerator(
      i18n('entities.resource.fields.status'),
      {
        options: resourceEnumerators.status,
      },
    ),
  },
  {
    name: 'description',
    label: i18n('entities.resource.fields.description'),
    schema: schemas.string(
      i18n('entities.resource.fields.description'),
      {},
    ),
  },
  {
    name: 'initDate',
    label: i18n('entities.resource.fields.initDate'),
    schema: schemas.datetime(
      i18n('entities.resource.fields.initDate'),
      {},
    ),
    render: (value) =>
      value && value instanceof Date
        ? moment(value).format('YYYY-MM-DD HH:mm')
        : value,
  },
  {
    name: 'endDate',
    label: i18n('entities.resource.fields.endDate'),
    schema: schemas.datetime(
      i18n('entities.resource.fields.endDate'),
      {},
    ),
    render: (value) =>
      value && value instanceof Date
        ? moment(value).format('YYYY-MM-DD HH:mm')
        : value,
  },
  {
    name: 'expirationDate',
    label: i18n('entities.resource.fields.expirationDate'),
    schema: schemas.datetime(
      i18n('entities.resource.fields.expirationDate'),
      {},
    ),
    render: (value) =>
      value && value instanceof Date
        ? moment(value).format('YYYY-MM-DD HH:mm')
        : value,
  },
  {
    name: 'relatedLocations',
    label: i18n(
      'entities.resource.fields.relatedLocations',
    ),
    schema: schemas.relationToMany(
      i18n('entities.resource.fields.relatedLocations'),
      {},
    ),
  },
  {
    name: 'relatedResources',
    label: i18n(
      'entities.resource.fields.relatedResources',
    ),
    schema: schemas.relationToMany(
      i18n('entities.resource.fields.relatedResources'),
      {},
    ),
  },
  {
    name: 'relatedAssets',
    label: i18n('entities.resource.fields.relatedAssets'),
    schema: schemas.relationToMany(
      i18n('entities.resource.fields.relatedAssets'),
      {},
    ),
  },
  {
    name: 'owner',
    label: i18n('entities.resource.fields.owner'),
    schema: schemas.relationToOne(
      i18n('entities.resource.fields.owner'),
      {},
    ),
  },
  {
    name: 'number',
    label: i18n('entities.resource.fields.number'),
    schema: schemas.integer(
      i18n('entities.resource.fields.number'),
      {},
    ),
  },
  {
    name: 'numberPrefix',
    label: i18n('entities.resource.fields.numberPrefix'),
    schema: schemas.string(
      i18n('entities.resource.fields.numberPrefix'),
      {},
    ),
  },
  {
    name: 'numberSuffix',
    label: i18n('entities.resource.fields.numberSuffix'),
    schema: schemas.string(
      i18n('entities.resource.fields.numberSuffix'),
      {},
    ),
  },
  {
    name: 'directoryPath',
    label: i18n('entities.resource.fields.directoryPath'),
    schema: schemas.string(
      i18n('entities.resource.fields.directoryPath'),
      {},
    ),
  },
  {
    name: 'actionPlans',
    label: i18n('entities.resource.fields.actionPlans'),
    schema: schemas.relationToMany(
      i18n('entities.resource.fields.actionPlans'),
      {},
    ),
  },
  {
    name: 'priority',
    label: i18n('entities.resource.fields.priority'),
    schema: schemas.enumerator(
      i18n('entities.resource.fields.priority'),
      {
        options: resourceEnumerators.priority,
      },
    ),
  },
];
